// Angular
import { Component } from '@angular/core';
// AG-Grid
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
// Others
import { Subject } from 'rxjs';
@Component({
	selector: 'cv-nexsys-custom-action-http-status-code',
	templateUrl: './custom-action-nexsys-http-status-code.component.html',
	styleUrls: ['./custom-action-nexsys-http-status-code.component.scss']
})
export class CustomActionNexsysHTTPStatusCodeComponent implements ICellRendererAngularComp {
	private atComponentDestroy: Subject<any> = new Subject<any>();
	public cellValue: any;
	public status: string;

	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.cellValue = params.data;
		this.status = this.cellValue.httpCodeResponse === 200 ? 'ACCEPTED' : 'FAILED';
	}

	/**
	 * Put back the value
	 * @param params
	 */
	refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		return true;
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
